module.exports = __webpack_public_path__ + "img/corriente_a_blue.03fe8322.svg";